// LiveKit URL resolver
const DEV_DEFAULT = "wss://madlen-spoken-dialogue-dev-9ne42nkq.livekit.cloud";
const PROD_DEFAULT = "wss://madlen-spoken-dialogue-ffzx1n0z.livekit.cloud";

export function getLivekitUrl(override?: string): string {
  // Priority:
  // 1. override argument
  // 2. VITE_LIVEKIT_URL from import.meta.env
  // 3. window.__LIVEKIT_URL__ (injected by hosting environment)
  // 4. default based on mode (production vs development)

  if (override) return override;

  const env = (import.meta as any)?.env || {};
  const envVar = env?.VITE_LIVEKIT_URL as string | undefined;
  const windowUrl =
    typeof window !== "undefined" ? (window as any).__LIVEKIT_URL__ : undefined;

  if (envVar) return envVar;
  if (windowUrl) return windowUrl;

  // Vite exposes env.MODE (string) and PROD (boolean)
  const mode = env?.MODE as string | undefined;
  const isProd = !!env?.PROD || mode === "production";

  return isProd ? PROD_DEFAULT : DEV_DEFAULT;
}
